import React from "react";
//  stles in app.css

const Home = () => {
  return (
    <>
      <header className="app_header">
        <h1 className="app_title">Stock Tracker</h1>
        <h5 className="app_subtitle">
          The Modern Stock Screener that helps you pick better stocks.
        </h5>
        <h6>Developed By Er. Soumyajit Pan</h6>
      </header>
    </>
  );
};

export default Home;
